/** Cloudflare Worker API client. All calls fail silently to keep the UI resilient. */

const API_BASE: string = import.meta.env.VITE_API_BASE ?? '/api'

export interface ApiVersion {
  name: string
  version: string
  runtime: string
}

export interface ApiHealth {
  status: string
}

async function fetchJson<T>(path: string, timeoutMs = 4000): Promise<T | null> {
  try {
    const controller = new AbortController()
    const timer = setTimeout(() => controller.abort(), timeoutMs)
    const response = await fetch(`${API_BASE}${path}`, {
      signal: controller.signal,
      headers: { accept: 'application/json' },
    })
    clearTimeout(timer)
    if (!response.ok) return null
    return (await response.json()) as T
  } catch {
    return null
  }
}

export function fetchApiVersion(): Promise<ApiVersion | null> {
  return fetchJson<ApiVersion>('/version')
}

export function fetchApiHealth(): Promise<ApiHealth | null> {
  return fetchJson<ApiHealth>('/health')
}
